/**
 * User: n.gorte
 * Date: 11.04.2019
 * Time: 16:59
 */
'use strict';

export const imageAvailable = url => new Promise((resolve, reject) => {
    const img = document.createElement('img');
    img.onload = resolve;
    img.onerror = reject;
    img.src = url;
});



// WEBPACK FOOTER //
// ./js/utils/imageAvailable.js